import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  PHeading,
  PIcon,
  PText,
} from '@porsche-design-system/components-react';

const Wrapper = styled('div', {
  base: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'xl',
    gap: 'md',
  },
});

export const UnexpectedError = ({
  heading,
  description,
}: {
  heading: string;
  description: string;
}) => (
  <Wrapper>
    <PIcon name="error-filled" size="xl" color="error" />
    <PHeading tag="h3" size="xl">
      {heading}
    </PHeading>
    <PText>{description}</PText>
  </Wrapper>
);
